module.exports = "/default/fonts/vendor/lightgallery.js/dist/lg.woff?5fd4c338c1a1b1eeeb2c7b0a0967773d";